import Loader from 'components/Loader';
import { useFormik } from 'formik';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardTitle, Col, Form, Input, Row } from 'reactstrap';
import { HEATLHCARE_HEADERS } from '../helpers';

const DoctorSystemDetails = ({ doctorId, doctorDetails }) => {
  const [updateDoctorRequest, { loading: updateDoctorLoading }] = useRequest({
    ...HEATLHCARE_HEADERS,
    url: `/healthcare/doctor/admin/${doctorId}`,
    method: 'PUT',
    onSuccess: () => {
      window.location.reload();
      toast.success('Success! Doctor has been updated.');
    },
    onError: (err) => {
      toast.error(err?.message);
      console.log(err);
    },
  });

  const getInitialValues = (details) => {
    return {
      active: details?.active,
      deleted: details?.deleted,
      isChildRelated: details?.isChildRelated,
      isClaimed: details?.isClaimed,
      isVerified: details?.isVerified,
      claimedDate: !isEmpty(details?.claimedDate)
        ? moment(details?.claimedDate)?.format('YYYY-MM-DD')
        : moment()?.format('YYYY-MM-DD'),
    };
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: !isEmpty(doctorDetails) ? getInitialValues(doctorDetails) : getInitialValues(),
    onSubmit: async (values) => {
      updateDoctorRequest({
        body: {
          ...values,
          ...(values?.isClaimed
            ? { claimedDate: moment(values?.claimedDate)?.toString() }
            : {
                claimedDate: undefined,
              }),
        },
      });
    },
  });

  return (
    <>
      <Loader isActive={updateDoctorLoading} />
      <Card className="mb-5">
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <Row className="align-items-center">
              {[
                {
                  name: 'Active',
                  value: 'active',
                },
                {
                  name: 'Deleted',
                  value: 'deleted',
                },
                {
                  name: 'isChildRelated',
                  value: 'isChildRelated',
                },
                {
                  name: 'isVerified',
                  value: 'isVerified',
                },
                {
                  name: 'isClaimed',
                  value: 'isClaimed',
                },
              ]?.map((data) => (
                <Col md={6} className="mb-2">
                  <CardTitle className="mb-3">{data?.name}</CardTitle>
                  {[true, false].map((option, i) => (
                    <div key={`${data?.value}_${i}`} className="form-check mb-3 d-inline-block me-4">
                      <input
                        type="radio"
                        id={`${data?.value}_${option}`}
                        name={data?.value}
                        className="form-check-input"
                        checked={formik.values[data?.value] === option}
                        onChange={() => formik.setFieldValue(data?.value, option)}
                      />
                      <label className="form-check-label" htmlFor={`${data?.value}_${option}`}>
                        {option ? 'Yes' : 'No'}
                      </label>
                    </div>
                  ))}
                </Col>
              ))}

              {formik.values.isClaimed && (
                <Col md={6} className="mb-2">
                  <CardTitle className="mb-3">Claimed Date</CardTitle>
                  <Input
                    type="date"
                    className="form-control"
                    placeholder="Enter Date"
                    value={formik.values.claimedDate}
                    onChange={(e) => {
                      formik.setFieldValue('claimedDate', e.target.value.trim());
                    }}
                  />
                </Col>
              )}
            </Row>

            <div className="mt-5">
              <Button type="submit" color="primary">
                Update Doctor
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};

export default DoctorSystemDetails;
